import { Entry } from '../Entry'

export function Entry20240508_2() {
  return (
    <Entry title="08/05/2023 - v3.7.1">
      Link to the{' '}
      <a
        href="https://workwave.atlassian.net/projects/RM/versions/15850/tab/release-report-all-issues"
        target="_blank"
        rel="noreferrer"
      >
        Jira Release
      </a>
    </Entry>
  )
}
